import Vue from 'vue';
import Router from 'vue-router';
import Index from '../views/Index.vue';
import Platform from '../views/Home/Home.vue';
import Home from '../views/Platform/Platform.vue';
import Introduce from '../views/Introduce/Introduce.vue';
import FangAn from '../views/Fangan/FangAn.vue';
import NewsIndex from '../views/Introduce/NewsIndex.vue';
import Store from '../views/Store/Store.vue';
import StoreDetails from '../views/Store/ProductList.vue';
import StoreDetails1 from '../views/Store/ProductList1.vue';
import StoreDetails2 from '../views/Store/ProductList2.vue';
import StoreList from '../views/Store/ProductDetails.vue';
import LianWang from '../views/LianWang/LianWang.vue';
import LianList from '../views/LianWang/LianList.vue';
import Builders from '../views/Builders/Builder.vue';
import ProductList from '../views/Product/Productlist.vue';
import PersonCenter from '../views/PersonCenter/PersonCenter.vue';
import Setting from '../views/PersonCenter/Setting.vue';
import Service from '../views/PersonCenter/Service.vue';
import Order from '../views/PersonCenter/Order.vue';
import Invoice from '../views/PersonCenter/Invoice.vue';
Vue.use(Router);
export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      redirect: '/Home',
      children: [
        {
          path: 'Home',
          name: 'Home',
          component: Home
        },
        {
          path: 'Service',
          name: 'Service',
          component: Service
        },
        {
          path: 'FangAn',
          name: 'FangAn',
          component: FangAn
        },
        {
          path: 'Invoice',
          name: 'Invoice',
          component: Invoice
        },
        {
          path: 'Order',
          name: 'Order',
          component: Order
        },
        {
          path: 'PersonCenter',
          name: 'PersonCenter',
          component: PersonCenter
        },
        {
          path: 'Setting',
          name: 'Setting',
          component: Setting
        },
        {
          path: 'Platform',
          name: 'Platform',
          component: Platform
        },
        {
          path: 'Introduce',
          name: 'Introduce',
          component: Introduce
        },
        {
          path: 'NewsIndex',
          name: 'NewsIndex',
          component: NewsIndex
        },
        {
          path: 'Store',
          name: 'Store',
          component: Store
        },
        {
          path: 'Store',
          name: 'Store',
          component: Store
        },
        {
          path: 'ProductList',
          name: 'ProductList',
          component: StoreDetails
        },
        {
          path: 'ProductList1',
          name: 'ProductList1',
          component: StoreDetails1
        },
        {
          path: 'ProductList2',
          name: 'ProductList2',
          component: StoreDetails2
        },
        {
          path: 'StoreList',
          name: 'StoreList',
          component: StoreList
        },
        {
          path: 'LianWang',
          name: 'LianWang',
          component: LianWang
        },
        {
          path: 'LianList',
          name: 'LianList',
          component: LianList
        },
        {
          path: 'ProductDetail',
          name: 'ProductDetail',
          component: ProductList
        },
        {
          path: 'Builders',
          name: 'Builders',
          component: Builders
        }
      ]
    }
  ],

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  }
});
